<template>
  <div class="content">
    <div class="img">
      <div class="img-box" v-for="item in list" :key="item.fileCode">
        <div>
          <video :src="item.fileHttpUrl" controls="controls" style="width: 100%">
            您的浏览器不支持 video 标签。
          </video>
        </div>
        <div class="p">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="pagination" style="text-align: center;margin: 20px 0;height: 30px;">
      <!-- :pageSizeOptions="pageSizeOptions" -->
      <a-pagination showQuickJumper showSizeChanger :total="total" :pageSize="6" :showTotal="total => `总共 ${total} 条`" :itemRender="itemRender" @change="onChange">
      </a-pagination>
    </div>
  </div>
</template>
  
<script>
import {
  getPlayer,
  getPlayerDetail,
} from '@/api/player.js'
import {
  getFileDetails
} from '@/api/file.js'
export default {
  name: 'sider-content-01',
  data () {
    return {
      list: [{ isSticky: 1 }, { isSticky: 1 }],
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList (page) {
      getPlayer(page).then(async (res) => {
        this.total = this._.get(res, 'data.total', 0)
        const list = this._.get(res, 'data.records', [])
        const fileList = []
        const fileObj = {}
        for (let i of list) {
          const fileRes = await getPlayerDetail(i.contentCode, i.tenantCode)
          const fileCode = this._.get(fileRes, 'data.contentNewsFileDtoList.0.fileCode', '')
          fileList.push(fileCode)
          fileObj[fileCode] = this._.get(fileRes, 'data.contentTitle', '')
        }
        getFileDetails(this._.get(res, 'data.records.0.appCode'), this._.get(res, 'data.records.0.tenantCode'), fileList).then(cres => {
          console.log('视频点播返回值', cres);
          this.list = this._.get(cres, 'data', {})
          Object.keys(fileObj).forEach(item => {
            this.list[item]['title'] = fileObj[item]
          })
        })
      })
    },
    onChange (pageNumber) {
      this.getList(pageNumber)
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return <li class="ant-pagination-item"><a>上页</a></li>;
      } else if (type === 'next') {
        return <li class="ant-pagination-item"><a>下页</a></li>;
      }
      return originalElement;
    },
  }
}
</script>
  
<style scoped lang='less'>
.top {
  position: absolute;
  width: 60px;
  text-align: center;
  color: #cbb486;
  z-index: 100;
  border-radius: 1px solid black;
}
.content {
  height: 600px;
  background: #dcdcdc;
  position: relative;
}
.title-box {
  padding-top: 28px;
  position: relative;
}
.back-title {
  width: 392px;
  height: 63px;
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 80px;
  opacity: 0.16;
}
.fron-title {
  width: 112px;
  height: 28px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 30px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 52px;
}
.img {
  width: 1200px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 29px;
  font-size: 0px;
  text-align: left;
}
.img-box {
  width: 360px;
  height: 235px;
  display: inline-block;
  font-size: 20px;
  position: relative;
  overflow: hidden;
  .p {
    margin: 0;
    padding: 0;
    width: 100%;
    line-height: 60px;
    background: #f8f8f8;
    position: absolute;
    bottom: 0;
    font-size: 16px;
    text-align: center;
    p {
      cursor: pointer;
      margin-top: 0px;
    }
    .p2 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-decoration: underline;
      color: #cab484;
      line-height: 36px;
    }
  }
  .p:hover {
    transition: bottom 2s;
    bottom: 0px;
    p {
      margin-top: 60px;
    }
    .p2 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-decoration: underline;
      color: #cab484;
      line-height: 36px;
    }
  }
}
.img-box:not(:nth-of-type(1)),
.img-box:not(:nth-of-type(2)),
.img-box:not(:nth-of-type(3)),
.img-box:not(:nth-of-type(4)),
.img-box:not(:nth-of-type(5)) {
  margin-bottom: 20px;
}
.img-box:not(:nth-of-type(5)),
.img-box:not(:nth-of-type(10)) {
  margin-right: 20px;
}
/deep/ .ant-pagination-item-active {
  border: none;
  background: #cbb486;
}
/deep/ .ant-pagination-item-active a {
  color: white;
}
/deep/ .ant-pagination-item:hover {
  background: #cbb486;
  border: none;
  color: white;
}
/deep/ .ant-pagination-item:hover a {
  color: white;
}
.pagination {
  position: absolute;
  bottom: 10px;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/player/siderContent-01.vue